// extracted by mini-css-extract-plugin
export default {"SwitchTabs":"SwitchTabs_SwitchTabs__uBFC1","selected":"SwitchTabs_selected__CJ2g4"};